import React from 'react'
import {logEvent} from '@lib/gtm'

type Props = {
  label: string
}

export function CTAButton({label}: Props) {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    const id = e.currentTarget.hash

    window.history.pushState(null, null, id)
    document.querySelector(id).scrollIntoView({behavior: 'smooth'})
  }

  return (
    <a
      href='#contact'
      className='AIReadiness__button'
      onClick={(e) => {
        scrollTo(e)
        logEvent({
          ga: {
            category: 'AI Readiness',
            action: 'Click CTA Banner',
            label,
          },
        })
      }}
    >
      ประเมินองค์กรเลย
    </a>
  )
}
